import { render, staticRenderFns } from "./StudyBulk.vue?vue&type=template&id=9d7f8d98&scoped=true&lang=pug"
import script from "./StudyBulk.vue?vue&type=script&lang=ts"
export * from "./StudyBulk.vue?vue&type=script&lang=ts"
import style0 from "./StudyBulk.vue?vue&type=style&index=0&id=9d7f8d98&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7f8d98",
  null
  
)

export default component.exports